export function isLoading(isLoading) {
    return async (dispatch) => {
        await dispatch({
            type: 'IS_LOADING',
            payload: isLoading
        })
    }
}

export function setError(errors) {
    return async (dispatch) => {
        await dispatch({
            type: 'SET_ERRORS',
            payload: errors
        })

        setTimeout(() => {
            // notification will disappear in 5s
            dispatch({
                type: 'SET_ERRORS',
                payload: []
            })

        }, 5000)
    }
}

export function setSuccessMessage({ title, subTitle }) {
    return async (dispatch) => {
        await dispatch({
            type: 'SET_SUCCESS_MESSAGE',
            payload: {
                title,
                subTitle
            }
        })

        setTimeout(() => {
            // notification will disappear in 1s
            dispatch({
                type: 'SET_SUCCESS_MESSAGE',
                payload: undefined
            })

        }, 1000)
    }
}